import { ALL_DATA_REPORT, DOWNLOAD_FETCH_CONSOLIDATED_INVOICE, FETCH_CONSOLIDATED_INVOICE, FETCH_CONSOLIDATED_INVOICE_EXCEL } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  invoiceLoader: false,
  reportLoader: false,
  alldatareport: [],
  consolidatedInvoice: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const alldatareportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ALL_DATA_REPORT.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_CONSOLIDATED_INVOICE.REQUEST: {
      return { ...state, reportLoader: true };
    }

    case DOWNLOAD_FETCH_CONSOLIDATED_INVOICE.REQUEST: {
      return { ...state, invoiceLoader: true };
    }

    case FETCH_CONSOLIDATED_INVOICE_EXCEL.REQUEST:
      return { ...state, isLoading: true };

    case ALL_DATA_REPORT.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        alldatareport: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case FETCH_CONSOLIDATED_INVOICE.SUCCESS: {
      return {
        ...state,
        reportLoader: false,
        consolidatedInvoice: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case DOWNLOAD_FETCH_CONSOLIDATED_INVOICE.SUCCESS: {
      return { ...state, invoiceLoader: false };
    }

    case FETCH_CONSOLIDATED_INVOICE_EXCEL.SUCCESS:
      return { ...state, isLoading: false };

    case ALL_DATA_REPORT.FAIL:
    case FETCH_CONSOLIDATED_INVOICE.FAIL:
    case DOWNLOAD_FETCH_CONSOLIDATED_INVOICE.FAIL:
      {
        return { ...state, invoiceLoader: false, reportLoader: false };
      }

    case FETCH_CONSOLIDATED_INVOICE_EXCEL.FAIL:
      return { ...state, isLoading: false, invoiceLoader: false };

    default:
      return { ...state };
  }
};
export default alldatareportReducer;
